export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Fachsemester:",
				type: "small",
			},
		],
	},
	{
		type: "special",
		id: 2,
		items: [
			{
				id: 2,
				text: "Studiengang:",
				label: [
					{
						id: 1,
						text: "Physik",
					},
					{
						id: 2,
						text: "Biophysik",
					},
					{
						id: 3,
						text: "Physik Lehramt",
					},
					{
						id: 4,
						text: "Quantum Engineering",
					},
					{
						id: 5,
						text: "Biologie",
					},
					{
						id: 6,
						text: "Chemie",
					},
					{
						id: 7,
						text: "Pharmazie",
					},
					{
						id: 8,
						text: "Sonstiges",
					},
				],
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 3,
				text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
			},
			{
				id: 4,
				text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
			},
			{
				id: 5,
				text: "Der Dozent/Die Dozentin begeisterte mich für das Fach.",
			},
			{
				id: 6,
				text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
			},
			{
				id: 7,
				text: "Der Dozent/Die Dozentin war fachlich kompetent.",
			},
			{
				id: 8,
				text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
			},
			{
				id: 9,
				text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
			},
			{
				id: 10,
				text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
			},
			{
				id: 11,
				text: "Das Lernziel wurde mir deutlich.",
			},
			{
				id: 12,
				text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
			},
			{
				id: 13,
				text: "Die Bewertungskriterien in der Veranstaltung wurden von vorneherein gut definiert.",
			},
			{
				id: 14,
				text: "Die Veranstaltung war übersichtlich und verständlich.",
			},
			{
				id: 15,
				text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
			},
			{
				id: 16,
				text: "Die Qualität der Unterrichtsmaterialien und -medien war gut.",
			},
			{
				id: 17,
				text: "Es wurden Anregungen zum vertiefenden Studium gegeben (z.B. Skripte, Weblinks).",
			},
			{
				id: 18,
				text: "Die Qualität des Unterrichtsraums und der technischen AusstaBung war gut.",
			},
			{
				id: 19,
				text: "Das Thema der Veranstaltung interessiert mich.",
			},
			{
				id: 20,
				text: "Das Thema der Veranstaltung ist als solches relevant.",
			},
			{
				id: 21,
				text: "Ich habe das Gefühl, in der Veranstaltung Wichtiges gelernt zu haben.",
			},
			{
				id: 22,
				text: "Das behandelte Thema enthält Bezüge zu meiner späteren Berufstätigkeit.",
			},
		],
	},
	{
		type: "bi",
		id: 4,
		items: [
			{
				id: 23,
				text: "Die Schwere des Stoffes war...",
			},
			{
				id: 24,
				text: "Der Umfang des Stoffes war...",
			},
			{
				id: 25,
				text: "Das Tempo der Veranstaltung war...",
			},
			{
				id: 26,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
			{
				id: 27,
				text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war...",
			},
			{
				id: 28,
				text: "Insgesamt empfand ich die Veranstaltung als...",
			},
		],
	},
	{
		type: "uni",
		id: 5,
		items: [
			{
				id: 29,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 30,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 31,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
			{
				id: 32,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
		],
	},
	{
		type: "text",
		id: 6,
		items: [
			{
				id: 33,
				text: "Durchschnittlicher Aufwand für die Veranstaltung in Stunden pro Woche:",
				type: "small",
			},
			{
				id: 34,
				text: "Besonders gut fand ich:",
			},
			{
				id: 35,
				text: "Störend fand ich:",
			},
			{
				id: 36,
				text: "Verbesserungsvorschläge:",
			},
			{
				id: 37,
				text: "Wurden Vorkenntnisse vorausgesetzt, die Ihnen gefehlt haben? Wenn ja, welche?",
			},
		],
	},
	{
		type: "text",
		id: 7,
		title: "Evaluation der Übung",
		items: [
			{
				id: 38,
				text: "Name des/der Übungsgruppenleiters/-leiterin",
				type: "medium",
			},
		],
	},
	{
		type: "uni",
		id: 8,
		items: [
			{
				id: 39,
				text: "Die Übungsaufgaben waren klar verständlich.",
			},
			{
				id: 40,
				text: "Die Anforderungen im Übungsbetrieb waren angemessen.",
			},
			{
				id: 41,
				text: "Übung und Vorlesung waren gut aufeinander abgestimmt.",
			},
			{
				id: 42,
				text: "Rückfragen wurden problemlos beantwortet.",
			},
			{
				id: 43,
				text: "Der Übungsgruppenleiter/Die Übungsgruppenleiterin konnte Inhalte gut vermitteln.",
			},
			{
				id: 44,
				text: "Der Übungsgruppenleiter/Die Übungsgruppenleiterin war auf jede Übung gut vorbereitet.",
			},
			{
				id: 45,
				text: "Der Übungsgruppenleiter/Die Übungsgruppenleiterin geht auf Fragen genügend ein.",
			},
		],
	},
	{
		type: "text",
		id: 9,
		items: [
			{
				id: 46,
				text: "Anmerkungen zur Übung",
			},
		],
	},
	{
		type: "uni",
		id: 10,
		title: "Evaluation des Seminars",
		items: [
			{
				id: 47,
				text: "Die Aufgabenstellung des Seminars war klar verständlich.",
			},
			{
				id: 48,
				text: "Die Anforderungen bezüglich des Seminarvortrags waren angemessen.",
			},
			{
				id: 49,
				text: "Seminar und Vorlesung waren gut aufeinander abgestimmt.",
			},
		],
	},
	{
		type: "text",
		id: 11,
		items: [
			{
				id: 50,
				text: "Anmerkungen zum Seminar",
			},
		],
	},
];
